// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__IWTZt","header":"MessagesList_header__gC-rF","chat":"MessagesList_chat__1Q2ta"};